import { Card, CardContent } from '@up2stay/up2promo-ui';
import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

/** Profiles SoT section title (`--t-h3`) for Product detail cards. */
export const PRODUCT_DETAIL_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

/** Profiles SoT body (`--t-body`). */
export const PRODUCT_DETAIL_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

/** Profiles SoT label (`--t-label`). */
export const PRODUCT_DETAIL_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

type ProductDetailSectionCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

/**
 * Shared Product-detail section shell — Card + Profiles density (`p-5 sm:p-6`).
 */
export function ProductDetailSectionCard({
  children,
  className,
  contentClassName,
}: ProductDetailSectionCardProps) {
  return (
    <Card className={cn('min-w-0 overflow-hidden', className)}>
      <CardContent
        className={cn('flex flex-col gap-3 p-5 sm:p-6', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
